import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CustomizedProgressBars from './CustomizedProgressBars';
import ClientProvider from './client';
export default createDemo(import.meta.url, CustomizedProgressBars, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/progress/demos/customized-bars/CustomizedProgressBars.tsx",
    "fileName": "CustomizedProgressBars.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { styled } from '@mui/material/styles';\nimport Stack from '@mui/material/Stack';\nimport CircularProgress, {\n  circularProgressClasses,\n} from '@mui/material/CircularProgress';\nimport type { CircularProgressProps } from '@mui/material/CircularProgress';\nimport LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';\n\nconst BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({\n  height: 10,\n  borderRadius: 5,\n  [`&.${linearProgressClasses.colorPrimary}`]: {\n    backgroundColor: theme.palette.grey[200],\n    ...theme.applyStyles('dark', {\n      backgroundColor: theme.palette.grey[800],\n    }),\n  },\n  [`& .${linearProgressClasses.bar}`]: {\n    borderRadius: 5,\n    backgroundColor: '#1a90ff',\n    ...theme.applyStyles('dark', {\n      backgroundColor: '#308fe8',\n    }),\n  },\n}));\n\n// Inspired by the former Facebook spinners.\nfunction FacebookCircularProgress(props: CircularProgressProps) {\n  return (\n    <CircularProgress\n      variant=\"indeterminate\"\n      disableShrink\n      enableTrackSlot\n      sx={(theme) => ({\n        color: '#1a90ff',\n        animationDuration: '550ms',\n        [`& .${circularProgressClasses.circle}`]: {\n          strokeLinecap: 'round',\n        },\n        [`& .${circularProgressClasses.track}`]: {\n          opacity: 1,\n          stroke: (theme.vars || theme).palette.grey[200],\n          ...theme.applyStyles('dark', {\n            stroke: (theme.vars || theme).palette.grey[800],\n          }),\n        },\n        ...theme.applyStyles('dark', {\n          color: '#308fe8',\n        }),\n      })}\n      size={40}\n      thickness={4}\n      aria-label=\"Loading…\"\n      {...props}\n    />\n  );\n}\n\n// From https://github.com/mui/material-ui/issues/9496#issuecomment-959408221\nfunction GradientCircularProgress() {\n  return (\n    <React.Fragment>\n      <svg width={0} height={0}>\n        <defs>\n          <linearGradient id=\"my_gradient\" x1=\"0%\" y1=\"0%\" x2=\"0%\" y2=\"100%\">\n            <stop offset=\"0%\" stopColor=\"#e01cd5\" />\n            <stop offset=\"100%\" stopColor=\"#1CB5E0\" />\n          </linearGradient>\n        </defs>\n      </svg>\n      <CircularProgress\n        aria-label=\"Loading…\"\n        sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }}\n      />\n    </React.Fragment>\n  );\n}\nexport default function CustomizedProgressBars() {\n  return (\n    <Stack spacing={2} sx={{ flexGrow: 1 }}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <FacebookCircularProgress />\n      <GradientCircularProgress />\n      <br />\n      <BorderLinearProgress\n        variant=\"determinate\"\n        value={50}\n        aria-label=\"Export data\"\n      />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </Stack>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 92,
        "focusedLines": 8,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { styled } from '@mui/material/styles';\nimport Stack from '@mui/material/Stack';\nimport CircularProgress, {\n  circularProgressClasses,\n} from '@mui/material/CircularProgress';\nimport type { CircularProgressProps } from '@mui/material/CircularProgress';\nimport LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';\n\nconst BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({\n  height: 10,\n  borderRadius: 5,\n  [`&.${linearProgressClasses.colorPrimary}`]: {\n    backgroundColor: theme.palette.grey[200],\n    ...theme.applyStyles('dark', {\n      backgroundColor: theme.palette.grey[800],\n    }),\n  },\n  [`& .${linearProgressClasses.bar}`]: {\n    borderRadius: 5,\n    backgroundColor: '#1a90ff',\n    ...theme.applyStyles('dark', {\n      backgroundColor: '#308fe8',\n    }),\n  },\n}));\n\n// Inspired by the former Facebook spinners.\nfunction FacebookCircularProgress(props: CircularProgressProps) {\n  return (\n    <CircularProgress\n      variant=\"indeterminate\"\n      disableShrink\n      enableTrackSlot\n      sx={(theme) => ({\n        color: '#1a90ff',\n        animationDuration: '550ms',\n        [`& .${circularProgressClasses.circle}`]: {\n          strokeLinecap: 'round',\n        },\n        [`& .${circularProgressClasses.track}`]: {\n          opacity: 1,\n          stroke: (theme.vars || theme).palette.grey[200],\n          ...theme.applyStyles('dark', {\n            stroke: (theme.vars || theme).palette.grey[800],\n          }),\n        },\n        ...theme.applyStyles('dark', {\n          color: '#308fe8',\n        }),\n      })}\n      size={40}\n      thickness={4}\n      aria-label=\"Loading…\"\n      {...props}\n    />\n  );\n}\n\n// From https://github.com/mui/material-ui/issues/9496#issuecomment-959408221\nfunction GradientCircularProgress() {\n  return (\n    <React.Fragment>\n      <svg width={0} height={0}>\n        <defs>\n          <linearGradient id=\"my_gradient\" x1=\"0%\" y1=\"0%\" x2=\"0%\" y2=\"100%\">\n            <stop offset=\"0%\" stopColor=\"#e01cd5\" />\n            <stop offset=\"100%\" stopColor=\"#1CB5E0\" />\n          </linearGradient>\n        </defs>\n      </svg>\n      <CircularProgress\n        aria-label=\"Loading…\"\n        sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }}\n      />\n    </React.Fragment>\n  );\n}\nexport default function CustomizedProgressBars() {\n  return (\n    <Stack spacing={2} sx={{ flexGrow: 1 }}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <FacebookCircularProgress />\n      <GradientCircularProgress />\n      <br />\n      <BorderLinearProgress\n        variant=\"determinate\"\n        value={50}\n        aria-label=\"Export data\"\n      />\n"
      ],
      [
        "span",
        "frame",
        "    </Stack>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 82
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "FacebookCircularProgress"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 83
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "GradientCircularProgress"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 84
            },
            [
              "      <",
              [
                "span",
                "pl-ent",
                "br"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 85
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "BorderLinearProgress"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 86
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "variant"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "determinate",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 87
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "value"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "50"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 88
            },
            [
              "        ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Export data",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 89
            },
            "      />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 92,
    "focusedLines": 8,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Stack",
      "@mui/material/CircularProgress",
      "@mui/material/LinearProgress"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
